// extracted by mini-css-extract-plugin
module.exports = {"searchWrapper":"style-module--searchWrapper--348uW","form":"style-module--form--2v6pJ"};